module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "default_service_icon.13eb1c78.svg";